import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import CommunityEngagementCentersDetails from '../../subdepartmentdetails/CommunityEngagementCenters'


function CommunityEngagementCenters() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Community Engagement and Resource Centers || Family and Children Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Family Community Services"
            title="Community Engagement Centers"
            subtitledown="Department of Family & Children Services"
           />
            <CommunityEngagementCentersDetails/>
        </div>
    </>
  )
}

export default CommunityEngagementCenters